import { render, staticRenderFns } from "./AccidentsInPast3Years.vue?vue&type=template&id=559388e0&"
import script from "./AccidentsInPast3Years.vue?vue&type=script&lang=js&"
export * from "./AccidentsInPast3Years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports